import { CodePage, CodeUniversEcran } from "@mra/hlp9002";

export type pageMesPossibilites =
  | CodePage.DETERMINATION_REVENU
  | CodePage.SOLUTIONS_A_DISPOSITION
  | CodePage.DIFFERENCES_RENTE_CAPITAL
  | CodePage.INFOS_REVERSION;

export class PageUtils {
  /**
   * récupère l'étape du parcours en fonction de l'url
   * @param url url
   * @returns numéro d'étape du parcours
   */
  public static getIndexBreadcrumbFromPage(url: string): number {
    //--- Parcours Simulation
    if (url.includes(CodePage.MON_EPARGNE)) return 0;

    if (url.includes(CodePage.MES_BESOINS)) return 1;

    if (
      url.includes(CodePage.DETERMINATION_REVENU) ||
      url.includes(CodePage.DIFFERENCES_RENTE_CAPITAL) ||
      url.includes(CodePage.SOLUTIONS_A_DISPOSITION) ||
      url.includes(CodePage.INFOS_REVERSION) ||
      url.includes(CodePage.PREINFORMATION)
    )
      return 2;

    if (
      url.includes(CodePage.SIMU_CONSO) ||
      url.includes(CodePage.MON_INFO_ALLIANZ) ||
      url.includes(CodePage.DETAILS_OPTION) ||
      url.includes(CodePage.CHOIX_OPTIONS)
    )
      return 3;

    if (url.includes(CodePage.MA_SYNTHESE)) return 4;

    //--- Parcours Projection
    if (url.includes(CodePage.PROJECTION)) return 0;

    //--- Parcours Prestation
    if (
      url.includes(CodePage.RECAP_DOCUMENTS) ||
      url.includes(CodePage.INFOS_PERSONNELLES) ||
      url.includes(CodePage.MES_BENEFICIAIRES) ||
      url.includes(CodePage.MA_FISCALITE) ||
      url.includes(CodePage.MON_PROFIL_FINANCIER) ||
      url.includes(CodePage.MON_EXPOSITION_POLITIQUE)
    )
      return 2;

    if (url.includes(CodePage.MA_CONFIRMATION)) return 4;

    //--- Parcours Versement volontaire
    if (url.includes(CodePage.MA_FISCALITE)) return 0;
    if (url.includes(CodePage.CHOIX_VERSEMENT)) return 1;
    if (url.includes(CodePage.MON_PROFIL_FINANCIER) || url.includes(CodePage.SAISIE_IBAN)) return 2;
    if (url.includes(CodePage.SYNTHESE_TELECHARGEMENTS)) return 3;
    if (
      url.includes(CodePage.TELECHARGEMENTS_JUSTIFICATIFS) ||
      url.includes(CodePage.SIGNATURE_TACTILE) ||
      url.includes(CodePage.MA_CONFIRMATION)
    )
      return 4;

    return 0;
  }

  /**
   * récupère le code page en fonction du code udp
   * @param codeUdp code udp
   * @returns code page de type mes possibilités
   */
  public static udpToCodePage(codeUdp: CodeUniversEcran): pageMesPossibilites {
    switch (codeUdp) {
      case CodeUniversEcran.CRH_CALCUL_COMPLEMENT_RETRAITE:
      case CodeUniversEcran.DETERMINATION_REVENUS:
        return CodePage.DETERMINATION_REVENU;

      case CodeUniversEcran.CRH_POSSIBILITES_PRESTATION:
      case CodeUniversEcran.SOLUTIONS_A_DISPOSITION:
        return CodePage.SOLUTIONS_A_DISPOSITION;

      case CodeUniversEcran.DIFFERENCES_RENTE_CAPITAL:
        return CodePage.DIFFERENCES_RENTE_CAPITAL;

      case CodeUniversEcran.INFOS_REVERSION:
        return CodePage.INFOS_REVERSION;
    }
  }
}
